'use client';

import { c as _c } from "react/compiler-runtime";
import useProducts from '@shared/utils/hooks/useProducts';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { client } from '../../utils/trpc';
import AutoTopUpLink from './AutoTopUpLink';
import Balance from './Balance';
import CommunityPoolCard from './CommunityPoolCard';
import PurchaseProducts from './PurchaseProducts';
const DonationModal = dynamic(() => import('../common/DonationModal'), {
  ssr: false
});
const TronsTabContent = () => {
  const $ = _c(15);
  const {
    products,
    isPremium,
    marginPercent
  } = useProducts(client);
  const [donationModalOpen, setDonationModalOpen] = useState(false);
  const [donationAmountCents, setDonationAmountCents] = useState(500);
  let t0;
  if ($[0] !== products) {
    t0 = products.find(_temp);
    $[0] = products;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const donationProduct = t0;
  let t1;
  if ($[2] !== isPremium || $[3] !== marginPercent) {
    t1 = <Balance isPremium={isPremium} marginPercent={marginPercent} />;
    $[2] = isPremium;
    $[3] = marginPercent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AutoTopUpLink />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CommunityPoolCard onOpenDonation={amountCents => {
      setDonationAmountCents(amountCents);
      setDonationModalOpen(true);
    }} />;
    t4 = <PurchaseProducts />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== donationAmountCents || $[9] !== donationModalOpen || $[10] !== donationProduct) {
    t5 = donationModalOpen && <DonationModal key={donationAmountCents} closeHandler={() => setDonationModalOpen(false)} product={donationProduct} initialAmountCents={donationAmountCents} />;
    $[8] = donationAmountCents;
    $[9] = donationModalOpen;
    $[10] = donationProduct;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <div className="flex flex-col gap-6">{t1}{t2}{t3}{t4}{t5}</div>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default TronsTabContent;
function _temp(product) {
  return product.type === "DONATION";
}